import { useMemo } from 'react'
import { EQUIPMENT_DETAILS_FORM_VALUES } from 'texts/equipmentDetails'
import { RuleType } from 'ui/molecules/Form/components/FormItem/types'

export const useValidationRules = () => {
  const validationRules: {
    [key: string]: {
      type: RuleType
      message?: string
      value?: (value: string | number) => { message: string } | boolean
    }[]
  } = useMemo(
    () => ({
      extraId: [
        {
          type: 'required',
          message:
            EQUIPMENT_DETAILS_FORM_VALUES.EQUIPMENT_NAME.REQUIRED_MESSAGE,
        },
      ],
      hirePoints: [
        {
          type: 'required',
          message: EQUIPMENT_DETAILS_FORM_VALUES.LOCATION.REQUIRED_MESSAGE,
        },
      ],
      priceFor: [
        {
          type: 'custom',
          value: (value: string | number) =>
            !Number(value) && {
              message: EQUIPMENT_DETAILS_FORM_VALUES.SUM_FOR.VALIDATION_MESSAGE,
            },
        },
      ],
    }),
    []
  )

  return validationRules
}
